import { css } from 'styled-components';

const sizes = {
    xLarge: 1000,
    large: 750,
    medium: 650,
};

/**
 * Create a min with media query using the sizes declared above.
 * Example:
 * (min-width: 42em)
 * @param {String} label
 */
export const createMinWidthQuery = (label) => `(min-width: ${sizes[label] / 16}em)`;
export const createMaxWidthQuery = (label) => `(max-width: ${sizes[label] / 16}em)`;

// Iterate through the sizes and create a media queries
export const mobileFirstQueries = Object.keys(sizes).reduce((acc, label) => {
    acc[label] = createMinWidthQuery(label);

    return acc;
}, {});

// Iterate through the sizes and create a media template
export const media = Object.keys(sizes).reduce((acc, label) => {
    acc[label] = (...args) => css`
        @media ${createMinWidthQuery(label)} {
            ${css(...args)}
        }
    `;

    return acc;
}, {});

// The following media queries are used for a non mobile first approach.
export const mediaMaxWidth = Object.keys(sizes).reduce((acc, label) => {
    acc[label] = (...args) => css`
        @media only screen and (max-width: ${sizes[label] / 16}em) {
            ${css(...args)}
        }
    `;

    return acc;
}, {});
